export const VERT = `#version 300 es
in vec2 a_position;
out vec2 v_uv;
void main() {
  v_uv = a_position * 0.5 + 0.5;
  gl_Position = vec4(a_position, 0.0, 1.0);
}
`;

export const MESH_FRAG = `#version 300 es
precision highp float;
uniform vec2 u_resolution;
uniform vec2 u_points[4];
uniform vec3 u_colors[4];
uniform float u_radii[4];
out vec4 fragColor;
void main() {
  vec2 frag = vec2(gl_FragCoord.x, u_resolution.y - gl_FragCoord.y);
  float minDim = min(u_resolution.x, u_resolution.y);
  vec3 color = vec3(0.0);
  float totalWeight = 0.0;
  for (int i = 0; i < 4; i++) {
    vec2 center = u_points[i] * u_resolution;
    float radiusPx = u_radii[i] * minDim;
    float normalizedDist = distance(frag, center) / radiusPx;
    if (normalizedDist < 1.5) {
      float t = max(0.0, 1.0 - normalizedDist);
      float weight = t * t * (3.0 - 2.0 * t);
      color += u_colors[i] * weight;
      totalWeight += weight;
    }
  }
  if (totalWeight <= 0.0) {
    fragColor = vec4(0.0);
    return;
  }
  color /= totalWeight;
  float alpha = min(1.0, totalWeight * (80.0 / 255.0));
  fragColor = vec4(color * alpha, alpha);
}
`;

export const DOWN_FRAG = `#version 300 es
precision highp float;
uniform sampler2D u_tex;
uniform vec2 u_offset;
in vec2 v_uv;
out vec4 fragColor;
void main() {
  vec2 hp = u_offset;
  vec4 c = texture(u_tex, v_uv) * 4.0;
  c += texture(u_tex, v_uv - hp);
  c += texture(u_tex, v_uv + hp);
  c += texture(u_tex, v_uv + vec2(hp.x, -hp.y));
  c += texture(u_tex, v_uv - vec2(hp.x, -hp.y));
  fragColor = c / 8.0;
}
`;

export const UP_FRAG = `#version 300 es
precision highp float;
uniform sampler2D u_tex;
uniform vec2 u_offset;
in vec2 v_uv;
out vec4 fragColor;
void main() {
  vec2 hp = u_offset;
  vec4 c = vec4(0.0);
  c += texture(u_tex, v_uv + vec2(-hp.x * 2.0, 0.0));
  c += texture(u_tex, v_uv + vec2(-hp.x, hp.y)) * 2.0;
  c += texture(u_tex, v_uv + vec2(0.0, hp.y * 2.0));
  c += texture(u_tex, v_uv + vec2(hp.x, hp.y)) * 2.0;
  c += texture(u_tex, v_uv + vec2(hp.x * 2.0, 0.0));
  c += texture(u_tex, v_uv + vec2(hp.x, -hp.y)) * 2.0;
  c += texture(u_tex, v_uv + vec2(0.0, -hp.y * 2.0));
  c += texture(u_tex, v_uv + vec2(-hp.x, -hp.y)) * 2.0;
  fragColor = c / 12.0;
}
`;

export const PRESENT_FRAG = `#version 300 es
precision highp float;
uniform sampler2D u_tex;
uniform vec2 u_offset;
in vec2 v_uv;
out vec4 fragColor;

float ign(vec2 p) {
  return fract(52.9829189 * fract(dot(p, vec2(0.06711056, 0.00583715))));
}

void main() {
  vec2 hp = u_offset;
  vec4 c = vec4(0.0);
  c += texture(u_tex, v_uv + vec2(-hp.x * 2.0, 0.0));
  c += texture(u_tex, v_uv + vec2(-hp.x, hp.y)) * 2.0;
  c += texture(u_tex, v_uv + vec2(0.0, hp.y * 2.0));
  c += texture(u_tex, v_uv + vec2(hp.x, hp.y)) * 2.0;
  c += texture(u_tex, v_uv + vec2(hp.x * 2.0, 0.0));
  c += texture(u_tex, v_uv + vec2(hp.x, -hp.y)) * 2.0;
  c += texture(u_tex, v_uv + vec2(0.0, -hp.y * 2.0));
  c += texture(u_tex, v_uv + vec2(-hp.x, -hp.y)) * 2.0;
  c /= 12.0;

  // Composite onto the page colour here. Dithering a faint transparent
  // layer is useless — the browser then multiplies that grain by alpha
  // and the rings come back. Dither the final pixels instead.
  float a = c.a;
  vec3 rgb = a > 0.0001 ? c.rgb / a : vec3(0.0);
  vec3 bg = vec3(0.0392157);
  vec3 comp = mix(bg, rgb, a) * 0.9 + bg * 0.1;

  float n1 = ign(gl_FragCoord.xy);
  float n2 = ign(gl_FragCoord.xy + vec2(19.19, 7.77));
  float tri = n1 + n2 - 1.0;
  float luma = dot(comp, vec3(0.2126, 0.7152, 0.0722));
  float strength = mix(3.4, 1.4, smoothstep(0.02, 0.18, luma)) / 255.0;
  fragColor = vec4(clamp(comp + tri * strength, 0.0, 1.0), 1.0);
}
`;
